import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ServicingBaseComponent } from '@common/components';
import { getMPropertyByKey } from '@common/helpers/ana-biz-application-list';
import { I18N_CONFIG } from '@conf/i18n.config';
import { DeviceType, SessionStorageName } from '@lib/interfaces';
import { CommonLibService } from '@lib/services';
import { AnaBizApplicationListStoreService } from '@common/services/ana-biz-application-list/ana-biz-application-list-store.service';

@Component({
  selector: 'asw-ana-biz-application-list-sub-header',
  templateUrl: './ana-biz-application-list-sub-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnaBizApplicationListSubHeaderComponent extends ServicingBaseComponent {
  /** 戻るボタン表示可否 */
  isBack: boolean = false;

  /** 発券申請種別 */
  activeApproverNum: number = 0;

  constructor(
    private _commonLibService: CommonLibService,
    private _anaBizApplicationListStoreService: AnaBizApplicationListStoreService
  ) {
    super(_commonLibService);
  }

  override init(): void {
    if (
      this._commonLibService.aswContextStoreService.aswContextData.lang === I18N_CONFIG.supportedLocales['ja'] &&
      this._commonLibService.aswContextStoreService.aswContextData.deviceType === DeviceType.PC
    ) {
      this.isBack = true;
    }
  }

  override reload(): void {}
  override destroy(): void {}

  /**
   * 現行ANABiz 企業データメンテナンス画面へ遷移
   */
  navigateAnaBizCompanyDataMaintenanceMenu() {
    const domain = getMPropertyByKey(this._commonLibService, 'url.anaBizCompanyDataMaintenanceMenuDispatch');
    const encryptedAnaBizAccessToken = localStorage.getItem('encryptedAnaBizAccessToken');

    if (!!domain && !!encryptedAnaBizAccessToken) {
      const anaBizParams = {
        anaBizAccessToken: encryptedAnaBizAccessToken || '',
      };
      const paramsString = new URLSearchParams(anaBizParams).toString();
      const url = `${domain}?LANG=ja&${paramsString}`;
      window.location.href = url;
    }
  }

  /**
   * 発券申請種別切り替え
   * @param index
   */
  approverTabClick(index: number) {
    this.activeApproverNum = index;
    this._anaBizApplicationListStoreService.updateAnaBizApplicationListStoreModel({
      activeApproverNum: index,
    });
  }
}
